export const TimeEstimate = ({ text }: { text: string }) => {
  return(
    <div className="border border-grey-400 bg-grey-200 p-1 rounded-full inline-flex items-center">
      <div className="w-8 h-8 rounded-circle bg-green-500 color-white p-1">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-full">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      </div>
      <span className="block mx-2 weight-600">{text}</span>
    </div>
  )
};